import { FormikProvider, useFormik } from "formik";
import DatePickers from "global/DatePicker/DatePicker";
import InputSelect from "global/InputSelect/InputSelect";
import InputText from "global/InputText/InputText";
import Modal from "global/Modal/Modal";
import SimpleButton from "global/SimpleButton/SimpleButton";
import CustomSwitch from "global/Switch/Switch";

import { questionBankValidation } from "global/Validation/Validation";
import { Dispatch, FC, SetStateAction, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { addEditDataAPI } from "services/CRUDServices";
import { getToday } from "tools/functions/Methods";
import AddAnswerTable from "./AddAnswerTable";
import { AiFillStar } from "react-icons/ai";
import MultiImageUploader from "components/importImage";

interface OptionType {
  id: number | string;
  text: string;
}

interface QuestionBankFormProps {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  refreshTable?: () => void;
  currentData?: any;
  setCurrentData?: any;
  options: {
    replyTypeSelect: OptionType[];
    questionTypeSelect: OptionType[];
    questionAssessmentMethodSelect: OptionType[];
  };
}

const QuestionBankForm: FC<QuestionBankFormProps> = ({
  open,
  setOpen,
  refreshTable,
  currentData,
  setCurrentData,
  options,
}) => {
  const [imageId, setImageId] = useState<any>(null);

  console.log(currentData);
  const formik = useFormik({
    enableReinitialize: true,
    validationSchema: questionBankValidation,
    initialValues: currentData
      ? {
          ...currentData,
          questionContentList: currentData.questionContentList || [],
          description: currentData.description || "",
        }
      : {
          title: "",
          isActive: true,
          validFrom: getToday(true),
          validTo: getToday(true),
          questionType: "",
          questionAssessmentMethod: "",
          selectReplyType: null,
          fromRange: 0,
          toRange: 0,
          description: "",
          questionContentList: [{ priority: 1, title: "" }],
        },
    onSubmit: async (values) => {
      // شبیه‌سازی کپی از مقادیر برای تغییر دادن قبل از ارسال
      let finalPayload = { ...values };
      const rId = values.selectReplyType?.id;
      console.log(values.selectReplyType)
      if (rId === 5) {
        console.log("run 5")
        // اگر متنی بود
        finalPayload.questionContentList = undefined;
        // description از قبل در values هست
      } else if (rId === 4) {
        // اگر ستاره ای (درجه بندی) بود
        finalPayload.questionContentList = [{ priority: 1, title: "5" }];
        finalPayload.description = "";
      } else if (rId === 3) {
        // اگر آپلود فایل بود
        finalPayload.questionContentList = undefined;
        finalPayload.fileId = imageId; // استفاده از استیت تصویر
      } else if (rId === 2) {
             console.log("run 2")
        // بله/خیر (در صورت نیاز به لیست پیش فرض)
        finalPayload.questionContentList = [
          { priority: 1, title: "بله" },
          { priority: 2, title: "خیر" },
        ];
      }
    console.log("finalPayload",finalPayload)
      try {
        await addEditDataAPI(
          currentData
            ? `/customer-api/question/v1/s1/edit`
            : "/customer-api/question/v1/s1/create",
          currentData?.id ? "put" : "post",
          finalPayload
        );
        refreshTable && refreshTable();
        setOpen(false);
        toast.success("عملیات با موفقیت انجام شد");
      } catch (error) {
        toast.error("خطا در ثبت اطلاعات");
      }
    },
  });

  const {
    handleSubmit,
    values,
    setFieldValue,
    touched,
    errors,
    resetForm,
    isSubmitting,
  } = formik;

  useEffect(() => {
    if (!open) {
      resetForm({});
      setImageId(null);
      if (setCurrentData) setCurrentData(null);
    }
  }, [open, resetForm, setCurrentData]);

  const replyTypeId = values.selectReplyType?.id;
  const isSpecialType = [2, 3, 4, 5].includes(Number(replyTypeId));

  return (
    <Modal visible={open} setVisible={setOpen} title="تعریف سوال">
      <FormikProvider value={formik}>
        <form onSubmit={handleSubmit} className="p-2">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 max-w-4xl">
            <InputText
              wrapperClassName="col-span-1 md:col-span-3"
              label="عنوان"
              important
              name="title"
              handleChange={(e) => setFieldValue("title", e.target.value)}
              values={values.title}
              error={touched.title && (errors.title as string)}
            />

            <InputSelect
              wrapperClassName="z-[102]"
              label="نوع نظرسنجی"
              important
              name="questionAssessmentMethod"
              handleChange={setFieldValue}
              values={values.questionAssessmentMethod}
              options={options?.questionAssessmentMethodSelect || []}
            />

            <InputSelect
              wrapperClassName="z-[101]"
              label="نوع سوال"
              important
              name="questionType"
              handleChange={setFieldValue}
              values={values.questionType}
              options={options?.questionTypeSelect || []}
            />

            <InputSelect
              wrapperClassName="z-[100]"
              label="نوع پاسخ"
              important
              name="selectReplyType"
              handleChange={setFieldValue}
              values={values.selectReplyType}
              options={options?.replyTypeSelect || []}
            />

            <DatePickers
              title="از تاریخ"
              name="validFrom"
              handleChange={setFieldValue}
              values={values.validFrom}
            />
            <DatePickers
              title="تا تاریخ"
              name="validTo"
              handleChange={setFieldValue}
              values={values.validTo}
            />

            <div className="flex items-center pt-8">
              <CustomSwitch
                active={values.isActive}
                handleChange={(v: any) => setFieldValue("isActive", v)}
              />
            </div>
          </div>

          <div className="mt-8 border-t pt-6">
            {replyTypeId === 5 && (
              <div className="space-y-2">
                <label className="text-sm font-bold">
                  متن راهنمای پاسخ (توضیحات):
                </label>
                <textarea
                  className="w-full p-3 border rounded-lg bg-gray-50 focus:bg-white transition-all"
                  rows={4}
                  name="description"
                  placeholder="این متن به عنوان توضیحات برای کاربر نمایش داده می‌شود..."
                  onChange={(e) => setFieldValue("description", e.target.value)}
                  value={values.description}
                  readOnly
                />
              </div>
            )}

            {replyTypeId === 4 && (
              <div className="flex flex-col items-center p-10 bg-yellow-50 border border-yellow-100 rounded-xl">
                <p className="text-yellow-700 font-bold mb-4">
                  پیش‌نمایش سیستم امتیازدهی ۵ ستاره
                </p>
                <div className="flex gap-2">
                  {[1, 2, 3, 4, 5].map((i) => (
                    <AiFillStar key={i} size={40} className="text-yellow-400" />
                  ))}
                </div>
              </div>
            )}

            {replyTypeId === 3 && (
              <div className="p-4 border-2 border-dashed rounded-xl">
                <MultiImageUploader onImageUploaded={(id) => setImageId(id)} />
              </div>
            )}

            {replyTypeId === 2 && (
              <div className="p-8 bg-blue-50 border border-blue-100 rounded-xl flex justify-center gap-12">
                <div className="flex items-center gap-2 font-bold text-blue-700">
                  <div className="w-5 h-5 border-2 border-blue-500 rounded-full" />{" "}
                  بله
                </div>
                <div className="flex items-center gap-2 font-bold text-blue-700">
                  <div className="w-5 h-5 border-2 border-blue-500 rounded-full" />{" "}
                  خیر
                </div>
              </div>
            )}

            {!isSpecialType && replyTypeId !== null && <AddAnswerTable />}
          </div>

          <div className="btnForm">
            <SimpleButton
              handelClick={() => setOpen(false)}
              text="لغو"
              className="bg-gray-100 px-8"
            />
            <SimpleButton
              type="submit"
              text={currentData ? "ویرایش" : "ثبت نهایی"}
              loading={isSubmitting}
              className="full-tomato-btn bg-[#7a1b2b]"
            />
          </div>
        </form>
      </FormikProvider>
    </Modal>
  );
};

export default QuestionBankForm;
